import { useState, useEffect, useRef, Fragment } from "react";
import { useHistory } from "react-router-dom";
import {
	API_URL,
	scroll,
	isFieldError,
	getValFromLS,
	setValToLS,
} from "../helpers";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Select from "../components/Select";
import Msg from "../components/Msg";
import Submit from "../components/Submit";
import Nav from "./Nav";

const Contact = () => {
	const [user, setUser] = useState({});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const formElement = useRef(null);
	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			const auth = getValFromLS("dash", true)
				? JSON.parse(getValFromLS("dash", true))
				: {};
			const url = new URL(`${API_URL}/dashboardContactInit`);
			const params = {
				id: auth.id ? auth.id : "",
				type: auth.type ? auth.type : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...JSON.parse(getValFromLS("dash", true)) });
					setNames({ ...json });
					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/dashboardContact`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "same") {
			} else {
				data.append(key, value);
			}
		});
		data.append("auth", getValFromLS("dash", true));
		data.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				let auth = JSON.parse(getValFromLS("dash", true));
				auth.fname = json.fname;
				auth.email = json.email;
				setValToLS("dash", JSON.stringify(auth), true);

				history.push("/dashboard");
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<Fragment>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<Fragment>
					<div id="left-column">
						<Hdg section="Update Contact Info" />

						<p>
							Use this form to make any updates to your contact information.
						</p>

						<div className="spacer"></div>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<h4
								style={{
									marginTop: "0",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Contact Information
							</h4>

							<div className="form-group">
								<Select
									name="prefix"
									label="Prefix"
									reqd={true}
									value={names.prefix || ""}
									options={[
										{ id: "", name: "--" },
										{ id: "Mr.", name: "Mr." },
										{ id: "Mrs.", name: "Mrs." },
										{ id: "Ms.", name: "Ms." },
										{ id: "Dr.", name: "Dr." },
										{ id: "Other", name: "Other" },
									]}
									update={handleUpdate}
									error={isFieldError(errors, "prefix")}
								/>
								<div className="empty" />
							</div>

							<div className="form-group">
								<Input
									name="fname"
									label="First Name"
									reqd={true}
									value={names.fname || ""}
									autocomplete="given-name"
									update={handleUpdate}
									errors={errors}
								/>

								<Input
									name="lname"
									label="Last Name"
									reqd={true}
									value={names.lname || ""}
									autocomplete="family-name"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group ">
								<Input
									name="email"
									label="Email"
									reqd={true}
									value={names.email || ""}
									update={handleUpdate}
									errors={errors}
								/>

								<Input
									name="phone"
									label="Phone"
									reqd={true}
									value={names.phone || ""}
									autocomplete="tel"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group">
								<Input
									name="title"
									label="Title"
									reqd={true}
									value={names.title || ""}
									autocomplete="organization-title"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="organization"
									label="Organization"
									reqd={true}
									value={names.organization || ""}
									autocomplete="organization"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<h4
								style={{
									marginTop: "15px",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Business Shipping Address
							</h4>

							<div className="form-group">
								<Input
									name="businessAddress"
									label="Address"
									reqd={true}
									value={names.businessAddress || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="businessAddress2"
									label="Address 2"
									reqd={false}
									value={names.businessAddress2 || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group three">
								<Input
									name="businessCity"
									label="City"
									reqd={true}
									value={names.businessCity || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="businessSt"
									label="State (2-letter)"
									reqd={true}
									value={names.businessSt || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="businessZip"
									label="Zip Code"
									reqd={true}
									value={names.businessZip || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<h4
								style={{
									marginTop: "15px",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Home Shipping Address
							</h4>

							<div className="form-group one">
								<Input
									name="homeAddress"
									label="Address"
									reqd={true}
									value={names.homeAddress || ""}
									autocomplete="street-address"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group three">
								<Input
									name="homeCity"
									label="City"
									reqd={true}
									value={names.homeCity || ""}
									autocomplete="address-level2"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="homeSt"
									label="State (2-letter)"
									reqd={true}
									value={names.homeSt || ""}
									autocomplete="address-level1"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="homeZip"
									label="Zip Code"
									reqd={true}
									value={names.homeZip || ""}
									autocomplete="postal-code"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit submit="Update Contact Info" />
								</div>
							</div>
						</form>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={5} user={user} />
					</div>
				</Fragment>
			)}
		</Fragment>
	);
};

export default Contact;
